import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
}

const SuccessModal = ({ isOpen, onClose, title = "Enviado com Sucesso!", message = "Recebemos suas informações e entraremos em contato em breve." }: SuccessModalProps) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-[90vw] sm:max-w-[400px] w-full bg-primary border-gold/20 text-primary-foreground text-center rounded-2xl">
        <DialogHeader className="flex flex-col items-center">
          <div className="w-20 h-20 bg-gold/10 rounded-full flex items-center justify-center mb-4">
            <CheckCircle2 className="w-12 h-12 text-gold animate-in zoom-in duration-300" />
          </div>
          <DialogTitle className="text-2xl font-heading text-gold">{title}</DialogTitle>
          <DialogDescription className="text-primary-foreground/70 text-base mt-2">
            {message}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-6">
          <Button onClick={onClose} className="w-full btn-gold font-bold">
            Entendido
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SuccessModal;
